import theme from '@styles/theme';

export const BACKGROUND_COLOR = theme.palette.common.white;
export const CELL_COLOR = '#D4DCEB';
export const DEFAULT_OPACITY = 0.5;
export const HORIZONTAL_SPACING = 0.5;
export const HOVERED_OPACITY = 1;
export const HOVER_DEBOUNCE_DELAY = 10;
export const MARGIN = 16;
export const MIN_DISPLAY_SIZE = 0.1;
export const RECTANGLE_BORDER_RADIUS = 4;
export const SEARCH_MATCH_COLOR = '#FFAB47';
export const SEARCH_PARENT_MATCH_COLOR = '#FFC37A';
export const TEXT_COLOR = theme.palette.grey[100];
export const TEXT_FONT_SIZE = 12;
export const TEXT_FONT = `${TEXT_FONT_SIZE}px ${theme.typography.h3.fontFamily}`;
export const TEXT_POSITION_IN_RECTANGLE_X = 8;
export const TOOLTIP_BG_COLOR = theme.palette.grey[100];
export const TOOLTIP_COLOR = theme.palette.common.white;
export const TOOLTIP_FONT_WEIGHT = theme.typography.fontWeightMedium;
export const TOOLTIP_WIDTH = 250;
export const VERTICAL_SPACING = 2;

const VERTICAL_PADDING = 12;
export const NODE_HEIGHT = TEXT_FONT_SIZE + 2 * VERTICAL_PADDING;

export const TEXT_POSITION_IN_RECTANGLE_Y = TEXT_FONT_SIZE + VERTICAL_PADDING;

export const ROOT_TREE_NODE_VALUE = 1;
